import React, {useState, useEffect} from "react"
import Grid from '@material-ui/core/Grid'
import pickAppStyle from "./pickAppStyle.jsx"
import withStyles from "@material-ui/core/styles/withStyles"

import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import moment from 'moment'

import CarouselArrow from '../Carousel/CarouselArrow'

const PickAppointment = ({classes, weekInterval, daySelected, setDaySelected}) => {

  const [dateList, setDateList] = useState([]);
  const [rightArrowEn, setRightArrowEn] = useState(true);
  const [leftArrowEn, setLeftArrowEn] = useState(false);

  useEffect(() => {
    const totalDays = 7*weekInterval;

    const start = moment().startOf('isoWeek');
    const today = moment().startOf('day');

    const days = [];

    for(let i = 0; i < totalDays; i++){
      let date = moment(start).add(i,'days');
      const dateObj = {
        id: date.format("DD-MM-YYYY"),
        date: date,
        enabled: date.isAfter(today, 'day') && date.isoWeekday() !== 7
      }
      days.push(dateObj);
    }

    setRightArrowEn(days.length > 7);

    setDateList(days);
  }, [weekInterval]);  

  const handleDayPick = (item) => {
    setDaySelected(item.date);
  };

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const matchesSm = useMediaQuery(theme.breakpoints.down('sm'));

  const days = dateList && dateList.map((item, idx) => (
      <div key={idx} className={classes.sliderContent}>
          <Grid container direction='column' alignItems='center' onClick={() => handleDayPick(item)} className={`${classes.dayContainer} ${!item.enabled && classes.dayContainerDisabled} ${daySelected.format("DD-MM-YYYY") === item.id && classes.daySelected}`}>
              <Grid className={classes.subTitle}>
                {item.date.format(matchesSm && !matches ? 'ddd' : 'dddd')}
              </Grid>
              <Grid className={classes.sectionTitleUnderline}>
                {item.date.format('DD')}
              </Grid>
              <Grid className={classes.subTitle}>
                {item.date.format(matchesSm && !matches ? 'MMM' : 'MMMM')}
              </Grid>
          </Grid>
      </div>
  ));



  const settings = {
    className: classes.sliderContent,
    infinite: false,
    slidesToShow: matches ?  3 : 7,
    slidesToScroll: matches ?  3 : 7,
    speed: 500,
    dots: false,
    arrows: true,
    afterChange: (next) => {            
        setLeftArrowEn(next > 0);
        setRightArrowEn(next + 7 < days.length);
    },
    nextArrow: <CarouselArrow arrowStyle={{right: '-4%', top: '30%', display: rightArrowEn ? 'initial' : 'none'}} color='black' direction='forward'/>,
    prevArrow: <CarouselArrow arrowStyle={{left: '-4%', top: '30%', display: leftArrowEn ? 'initial' : 'none'}} color='black' direction='back'/>
  };

  return (
    <div style={{width: '100%', marginTop: '20px', maxWidth: '1200px'}}>
        <Slider {...settings} className={classes.slider}>
            {days}
        </Slider>
    </div>
  );

}

export default withStyles(pickAppStyle)(PickAppointment)
